import { createFileRoute, Link } from "@tanstack/react-router";
import { SettingsPageShell } from "@/features/settings";

function InviteLinksRetiredPage() {
  return (
    <SettingsPageShell
      title="Invite Links"
      description="Invite links have been replaced by WorkOS email invitations."
    >
      <div className="space-y-3">
        <p className="text-sm text-muted-foreground">
          Use Members & Roles to invite teammates, resend pending invitations, or revoke access.
        </p>
        <Link
          to="/settings/members-roles"
          className="inline-flex h-9 items-center justify-center rounded-md border border-input bg-background px-3 font-medium text-sm hover:bg-accent hover:text-accent-foreground"
        >
          Members & Roles
        </Link>
      </div>
    </SettingsPageShell>
  );
}

export const Route = createFileRoute("/settings/invite-links")({
  component: InviteLinksRetiredPage,
});
